// Custom constants defined on our side
export const ASK_AI_HEADER_BTN_ENTRY_POINT = 'ASK_AI_HEADER_BTN_ENTRY_POINT';

// Custom constant defined on our side and PDP side to differentiate custom PDP prompt events.
// This is currently unused on the navigation side but exported to be preserved for future needs
// since the PDP side passes this event source.
export const ASK_AI_SOURCE_CUSTOM_PDP_PROMPT = 'ASK_AI_SOURCE_CUSTOM_PDP_PROMPT';

export const FLOATING_ENTRY_POINT = 'google-agent-floating-entry-point';
export const EVENT_SOURCE_PDP_PROMPT = 'EVENT_SOURCE_PDP_PROMPT';
export const EVENT_SOURCE_AI_OVERVIEW = 'EVENT_SOURCE_AI_OVERVIEW';
